import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HrmUserTimeSummaryService {


  url = environment.serverAPI4 + "/api/hrmUserTimeSummary";

  constructor(private http: HttpClient) { }

  getAllhrmUserTimeSummary(Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }

  getAllHrmUserTimeSummaryDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }

  getHrmUserTimeSummaryById(id: number): Observable<Object> {
    return this.http.get(`${this.url}/${id}`);
  }

  addOrEditHrmUserTimeSummary(hrmUserTimeSummary: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, hrmUserTimeSummary);
  }
}
